import { useMutation, useQuery } from "@tanstack/react-query";
import { queryClient } from "@/src/config/react-query";
import { getNotifications, markAllNotificationAsRead, markNotificationAsRead, sendNotification } from "./notification.service";

export type GetNotificationsParams = {
  Page: number;
  PageSize: number;
  IsUnreadOnly?: boolean;
  SortProperty?: string;
  SortIsDescending?: boolean;
};

export const useGetNotifications = (params: GetNotificationsParams) => {
  return useQuery({
    queryKey: ["notifications",
      params.Page,
      params.PageSize,
      params.IsUnreadOnly,
      params.SortProperty,
      params.SortIsDescending
    ],
    queryFn: () => getNotifications(params),
    staleTime: 5 * 60 * 1000,
  });
};

export const useMarkNotificationAsRead = () => {
  return useMutation({
    mutationFn: markNotificationAsRead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
    },
  });
};

export const useMarkAllNotificationAsRead = () => {
  return useMutation({
    mutationFn: markAllNotificationAsRead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
    },
  });
};

export const useSendNotification = () => {
  return useMutation({
    mutationFn: sendNotification,
  });
};
